// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-links[data-v-93a3f0bc]{display:flex;flex-direction:column;align-items:center}.social-links__link[data-v-93a3f0bc]{text-decoration:none}.social-links__link i[data-v-93a3f0bc]{color:#36134a}.social-links__link[data-v-93a3f0bc]:hover{opacity:.8}@media(max-width:767px){.social-links__text[data-v-93a3f0bc]{max-width:215px}}", ""]);
// Exports
module.exports = exports;
